import {useCollection} from 'react-firebase-hooks/firestore'
import {toDataPairs} from '@web/lib/firestore.db'
import {FirestoreError, Query} from "firebase/firestore";

/**
 * useQueryFirestore
 * @function useQueryFirestore
 * @param {Query} query
 * @param {boolean} [asDocs=false] - If true, returns documents instead of data pairs
 * @returns {[DataItem[],boolean,FirestoreError]}
 */
const useQueryFirestore = (query, asDocs = false) => {
  const [querySnapshot, isLoading, error] = useCollection(query)
  error &&
  console.log('useQueryFirestore', error.code, error.message, query);
  return asDocs ?
    [querySnapshot?.docs ?? [], isLoading, error] :
    [toDataPairs(querySnapshot), isLoading, error]
}

export default useQueryFirestore
